export const EDITABLE_CELL_FIELD_TYPES = {
    INPUT: "input",
    TIME_PICKER: "timePicker",
}